import { renderDocsUi } from "@sg-widgets/docs-ui";

if (window.__SG_WIDGETS_DOCS_UI__MDX_FILE__) {
  import(
    /* webpackChunkName: "docs/[request]" */
    /* webpackInclude: /\.mdx$/ */
    "./docs-ui-mdx-marker-folder/" + window.__SG_WIDGETS_DOCS_UI__MDX_FILE__
  ).then(mdxModule => {
    renderDocsUi(
      window.__SG_WIDGETS_DOCS_UI_WIDGET_PROJECT__,
      mdxModule.default
    );
  });
} else {
  renderDocsUi(window.__SG_WIDGETS_DOCS_UI_WIDGET_PROJECT__);
}
